export default () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_1_3123"
        //style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="5"
        y="8"
        width="14"
        height="9"
      >
        <path
          d="M18 9.5L12 15.5L6 9.5L18 9.5Z"
          fill="white"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1_3123)">
        <path d="M24 24L0 24L2.09815e-06 -2.09815e-06L24 0L24 24Z" fill="#F56565" />
      </g>
    </svg>
  );
};
